import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as ExpoCrypto from 'expo-crypto';
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { TextInput, HelperText } from 'react-native-paper';
export const ValidatedInput = forwardRef(({ testID = 'validated-input', mode = 'outlined', value = '', ...props }, ref) => {
    const inputRef = useRef(null);
    useEffect(() => {
        if (value) {
            validateInput(value);
        }
    }, [value, props.reValidate]);
    useImperativeHandle(ref, () => ({
        isValid: () => validateInput(value),
        focus: () => inputRef.current?.focus(),
    }));
    const validateInput = (value) => {
        const fieldErrors = new Array();
        props.rules?.forEach((validator) => {
            const error = validator(value);
            if (error) {
                fieldErrors.push(error);
            }
        });
        if (props.onValidate) {
            props.onValidate(fieldErrors);
        }
        return fieldErrors.length === 0;
    };
    const onBlur = (event) => {
        validateInput(value);
        if (props.onBlur) {
            props.onBlur(event);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(TextInput, { testID: `${testID}-input`, ...props, ref: inputRef, value: value, mode: mode, error: props.errors && props.errors.length > 0, onBlur: onBlur }), !props.hideErrors &&
                props.errors?.map((error, index) => (_jsx(HelperText, { testID: `${testID}-error-${index}`, type: 'error', style: props.errorsStyle, children: error }, ExpoCrypto.randomUUID())))] }));
});
